import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  container: {
    display: 'flex',
    gap: '8px',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
  },
  containerDark: {
    display: 'flex',
    gap: '8px',
    color: 'black',
    cursor: 'pointer',
    alignItems: 'center',
    fontSize: '14px',
  },
}))
